import helpers from '../helpers/helpers';

export const parseToInt = (value: string | number = ''): number | '' =>
  value === '' ? value : Number.parseInt(helpers.thousandSeparatorUnformat(value), 10);

export const parseToFloat = (value: string | number = ''): number | '' =>
  value === '' ? value : Number.parseFloat(helpers.thousandSeparatorUnformat(value).replace(',', '.'));
